module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("b4I0m"))).then(() => parcelRequire('1iHdE'));